import React, { useMemo } from "react";
import { useLocation } from "react-router-dom";
import { Box, Paper, Typography, Button, Stack, Chip } from "@mui/material";

function useQuery() {
  const { search } = useLocation();
  return useMemo(() => new URLSearchParams(search), [search]);
}

const OFFICES = {
  zw: { label: "Reply to Zim Office", email: "abisiniyatravels@gmail.com" },
  sa: { label: "Reply to SA Office", email: "saoffice@abisiniya.com" },
};

function buildMailto({ to, subject, body }) {
  const params = new URLSearchParams();
  if (subject) params.set("subject", subject);
  if (body) params.set("body", body);
  return `mailto:${encodeURIComponent(to)}?${params.toString()}`;
}

export default function PublicReplyPage() {
  const q = useQuery();

  const office = (q.get("office") || "").toLowerCase(); // "zw" or "sa" (optional)
  const campaignId = q.get("campaign_id") || "";
  const recipientEmail = q.get("email") || "";
  const recipientName = q.get("name") || "";
  const campaignSubject = q.get("subject") || "";

  const subjectLine =
    campaignSubject
      ? `Re: ${campaignSubject}`
      : "Re: Abisiniya Travel Enquiry";

  const bodyText =
`Hi Abisiniya Team,

I’m replying to your email.

Name: ${recipientName || "-"}
Email: ${recipientEmail || "-"}
Campaign ID: ${campaignId || "-"} 

Message:
`;

  const showSingle = office === "zw" || office === "sa";
  const primaryOffice = showSingle ? office : null;

  const openMail = (officeKey) => {
    const to = OFFICES[officeKey].email;
    const mailto = buildMailto({ to, subject: subjectLine, body: bodyText });
    window.location.href = mailto; // works on mobile + desktop (opens email app)
  };

  return (
    <Box sx={{ minHeight: "100vh", display: "flex", alignItems: "center", justifyContent: "center", p: 2, bgcolor: "#f4f7f9" }}>
      <Paper sx={{ width: "100%", maxWidth: 560, p: 3, borderRadius: 3 }}>
        <Typography variant="h6" fontWeight={800} sx={{ mb: 1 }}>
          Reply to Abisiniya Travel
        </Typography>

        <Stack direction="row" spacing={1} sx={{ mb: 2, flexWrap: "wrap" }}>
          {campaignId ? <Chip label={`Campaign: ${campaignId}`} /> : null}
          {recipientEmail ? <Chip label={recipientEmail} /> : null}
        </Stack>

        <Typography variant="body2" color="text.secondary" sx={{ mb: 2 }}>
          Tap a button to open your email app with a prefilled reply.
        </Typography>

        <Stack spacing={1.5}>
          {showSingle ? (
            <Button
              variant="contained"
              size="large"
              onClick={() => openMail(primaryOffice)}
            >
              {OFFICES[primaryOffice].label}
            </Button>
          ) : (
            <>
              <Button variant="contained" size="large" onClick={() => openMail("zw")}>
                {OFFICES.zw.label}
              </Button>
              <Button variant="contained" size="large" onClick={() => openMail("sa")}>
                {OFFICES.sa.label}
              </Button>
            </>
          )}
        </Stack>

        <Typography variant="caption" color="text.secondary" sx={{ mt: 2, display: "block" }}>
          If nothing opens, make sure you have a mail app configured on this device.
        </Typography>
      </Paper>
    </Box>
  );
}
